import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles/SearchResults.scss';

const SearchResults = ({ onClick, searchTerm, totalResults }) => {
    return (
        <div className={styles.searchResults}>
            <div className={styles.count}>
                {totalResults} results for
                <span className={styles.term}> "{searchTerm}"</span>
            </div>
            <div className={styles.returnToAll} onClick={onClick}>
                Return to all items
            </div>
        </div>
    );
};

SearchResults.propTypes = {
    onClick: PropTypes.func,
    searchTerm: PropTypes.string,
    totalResults: PropTypes.number,
};

export default SearchResults;
